import "../DrugOrderConfirmLotTable/DrugOrderConfirmLotTable.css";

const DrugOrderConfirmSequenceTable = ({ data }) => {
  return (
    <div className="drug-order-confirm-lot-table-container">
      <table className="drug-order-confirm-lot-table">
        <thead className="drug-order-confirm-lot-table-header">
          <tr>
            <th className="drug-order-confirm-table-header-name">Drug Name</th>
            <th className="drug-order-confirm-table-header-name">
              Min Sequence Number
            </th>
            <th className="drug-order-confirm-table-header-name">
              Max Sequence Number
            </th>
          </tr>
        </thead>
        <tbody style={{ textAlign: "center" }}>
          {data &&
            data?.map((item, index) => (
              <tr key={index}>
                <td className="drug-order-confirm-table-data">
                  {item.drugName}
                </td>
                <td className="drug-order-confirm-table-data">
                  {item.minSequenceNumber}
                </td>
                <td className="drug-order-confirm-table-data">
                  {item.maxSequenceNumber}
                </td>
              </tr>
            ))}
        </tbody>
      </table>
    </div>
  );
};

export default DrugOrderConfirmSequenceTable;
